/**************************************************
 * Nombre:       Seccion_Metricas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_CONTAR_ARR,
    CASILLA_FECHA_DATO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useEffect, useRef, useState} from "react";
import Tarjeta_Titulo_Subtitulo_Grafica_Larga
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Larga";
import Linea_Limpia from "../../Modulo_Graficas/Graficas/Linea_Limpia";
import Barras_Horizontales_Nombre from "../../Modulo_Graficas/Graficas/Barras_Horizontales_Nombre";
import {useObtenerAlto} from "../../Modulo_Graficas/Hooks/useObtenerAlto";
import {arrConteoColMesesAtras} from "../../Servicios/BD/Contadores_Arr/arrConteoColMesesAtras";
import {contarWheres} from "../../Servicios/BD/Contadores/contarWheres";
import {collection, limit, orderBy, query, where} from "firebase/firestore";
import Barra_Horizontal_Limpia from "../../Modulo_Graficas/Graficas/Barra_Horizontal_Limpia";
import Tarjeta_Titulo_Subtitulo_Grafica_Alta
    from "../../Modulo_Graficas/Componentes/Tarjetas/Tarjeta_Titulo_Subtitulo_Grafica_Alta";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {fire} from "../../fire";
import Dialogo_Metricas from "../Dialogos/Dialogo_Metricas";


const Seccion_Metricas = () => {
    const refe = useRef()
    const refeDos = useRef()
    const altoGraficas = 190
    const {alto} = useObtenerAlto({contenedor: refe})
    const {alto: altoDos} = useObtenerAlto({contenedor: refeDos})
    const [numPedidos, setNumPedidos] = useState([])
    const [locales, setLocales] = useState([])
    const [globales, setGlobales] = useState([])
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'metricas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Metricas,
        titulo: 'Detalles del Usuario',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
        }
    }


    const obtenerDatos = async () => {


        let doxPedidos = await arrConteoColMesesAtras({coleccion: 'metricas', mesesAtras: 12})
        setNumPedidos(doxPedidos)


        let w = [where('nombre', '!=', null)]
        let registrados = await contarWheres({coleccion: 'metricas', wheres: w})
        let noRegistrados = await contarWheres({coleccion: 'metricas', wheres: []})

        let arr = [
            {
                nombre: 'Suscritos',
                cantidad: registrados.data
            },
            {
                nombre: 'No Suscritos',
                cantidad: noRegistrados.data - registrados.data
            },
        ]

        setLocales(arr)

        let q = query(collection(fire, 'metricasGlobales'), orderBy('cantidad', 'desc'), limit(10))
        let doxGlobales = await obtenerColeccionQuery(q)
        setGlobales(doxGlobales.data)


    }



    useEffect(() => {

        obtenerDatos().then((data) => {
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid ref={refe} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Usuarios Nuevos'}
                        subtitulo={'Ultimos 12 meses'}
                        Grafica={Linea_Limpia}
                        marginTop={12}
                        height={altoGraficas}
                        series={
                            [
                                {
                                    name: new Date().getFullYear(),
                                    data: numPedidos.map((it) => it.cantidad)

                                }
                            ]
                        }
                        labels={numPedidos.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: alto}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Larga
                        titulo={'Segun'}
                        subtitulo={'suscripcion'}
                        Grafica={Barras_Horizontales_Nombre}
                        marginTop={20}
                        height={altoGraficas - 40}
                        series={
                            [{
                                name: 'usuarios',
                                data: locales.map((e) => e.cantidad)
                            }]
                        }

                        labels={['Suscritos', 'No Suscritos']}/>
                </Grid>

                <Grid ref={refeDos} container size={{xs: 12, sm: 12, md: 8}}>
                    <Tabla_Filtro
                        nombre={'Usuarios que navegaron'}
                        descripcion={`${numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        // clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 3, md: 4}}
                      sx={{height: altoDos}}
                >
                    <Tarjeta_Titulo_Subtitulo_Grafica_Alta
                        titulo={'Productos'}
                        subtitulo={'en carrito'}
                        Grafica={Barra_Horizontal_Limpia}
                        marginTop={10}
                        height={altoDos - 80}
                        series={
                            [{
                                name: 'En carritos',
                                data: globales.map((e) => e.cantidad)
                            }]
                        }

                        labels={globales.map((e) => e.nombre)}/>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Metricas

const filtros = [

    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [
    {
        nombre: 'Num Vistas',
        direccion: 'left',
        propiedad: 'vistaPagina',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO

    },
    {
        nombre: 'Nombre/UID',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: 'id',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'En Carrito',
        direccion: 'right',
        propiedad: 'productos',
        tipo: CASILLA_CONTAR_ARR

    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]


